import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { SpEditorModule } from '@components/sp-editor';
import he from 'he';

import type { Uuid } from '@common/types';
import { ThemeStateService } from '@sites/site-theme/src/state';
import type { DeviceMode } from '@common/types/layout.type';

@Component({
    selector: 'sp-common-editor',
    templateUrl: './sp-editor-common.component.html',
    styleUrls: ['./sp-editor-common.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SpEditorModule],
})
export class SpCommonEditorComponent {
    @Input() public inline?: boolean = true;
    @Input() public content: string;
    @Input() public containerId: Uuid;
    @Input() public changeContentOnKeyUp: boolean = true;
    @Input() public toolbarMenu: string;
    @Input() public placeholder: string;
    @Input() public baseHref: string;
    @Input() public deviceMode: DeviceMode;

    @Output() public changeContent = new EventEmitter<string>();
    @Output() public focusInEvent = new EventEmitter<void>();
    @Output() public focusOutEvent = new EventEmitter<string>();
    @Output() public isEmptyContent = new EventEmitter<boolean>();

    private readonly themeState = inject(ThemeStateService);

    public readonly selectedThemeColors = this.themeState.selectedColors;

    public changeHandler(value: string) {
        const strippedVal = he.decode(value.replace(/(<([^>]+)>)/gi, '')).trim();

        if (strippedVal.length === 0) {
            return this.changeContent.emit(strippedVal);
        }
        this.changeContent.emit(value);
    }
}
